import { combineEpics, Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import {
  switchMap,
  map,
  startWith,
  catchError,
  filter,
} from 'rxjs/operators';
import { isOfType } from 'typesafe-actions';

import {
  WebhookActions,
  WebhookActionTypes,
  createdWebhook,
  creatingWebhook,
  creatingWebhookFailed,
  updatedWebhook,
  updatingWebhook,
  updatingWebhookFailed,
  deletedWebhook,
  deletingWebhook,
  deletingWebhookFailed,
} from '../actions/webhookActions';
import { IState } from '../reducers';
import {
  createWebhook,
  updateWebhook,
  deleteWebhook,
} from '../../services/webhookApi';

const createWebhookEpic: Epic<WebhookActions, WebhookActions, IState, any> = (
  action$: any,
  state$: any,
  { dispatch }: any
) =>
  action$.pipe(
    filter(isOfType(WebhookActionTypes.CREATE_WEBHOOK)),
    switchMap((action: any) =>
      from(createWebhook(action.payload.webhook)).pipe(
        map((response: any) => createdWebhook(response.result)),
        startWith(creatingWebhook()),
        catchError(() => of(creatingWebhookFailed()))
      )
    )
  );

const updateWebhookEpic: Epic<WebhookActions, WebhookActions, IState, any> = (
  action$: any,
  state$: any,
  { dispatch }: any
) =>
  action$.pipe(
    filter(isOfType(WebhookActionTypes.UPDATE_WEBHOOK)),
    switchMap((action: any) =>
      from(updateWebhook(action.payload.uid as string, action.payload.webhook)).pipe(
        map((response: any) => updatedWebhook(response.result)),
        startWith(updatingWebhook()),
        catchError(() => of(updatingWebhookFailed()))
      )
    )
  );

const deleteWebhookEpic: Epic<WebhookActions, WebhookActions, IState, any> = (
  action$: any,
  state$: any,
  { dispatch }: any
) =>
  action$.pipe(
    filter(isOfType(WebhookActionTypes.DELETE_WEBHOOK)),
    switchMap((action: any) =>
      from(deleteWebhook(action.payload)).pipe(
        map((response: any) => deletedWebhook()),
        startWith(deletingWebhook()),
        catchError(() => of(deletingWebhookFailed()))
      )
    )
  );

export default combineEpics(
  createWebhookEpic,
  updateWebhookEpic,
  deleteWebhookEpic,
);
